<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="props.size" :background="props.background" viewBox="0 0 16 16">
    <path
      d="M0.0610352 1.67575C0.0610352 1.18901 0.455615 0.794434 0.942354 0.794434H15.0435C15.5302 0.794434 15.9248 1.18901 15.9248 1.67575V1.67575C15.9248 2.16249 15.5302 2.55707 15.0435 2.55707H0.942355C0.455616 2.55707 0.0610352 2.16249 0.0610352 1.67575V1.67575ZM0.0610352 14.8955C0.0610352 14.4088 0.455615 14.0142 0.942354 14.0142H15.0435C15.5302 14.0142 15.9248 14.4088 15.9248 14.8955V14.8955C15.9248 15.3823 15.5302 15.7769 15.0435 15.7769H0.942355C0.455616 15.7769 0.0610352 15.3823 0.0610352 14.8955V14.8955ZM0.0610352 10.4889C0.0610352 10.0022 0.455615 9.60763 0.942354 9.60763H15.0435C15.5302 9.60763 15.9248 10.0022 15.9248 10.4889V10.4889C15.9248 10.9757 15.5302 11.3703 15.0435 11.3703H0.942355C0.455616 11.3703 0.0610352 10.9757 0.0610352 10.4889V10.4889ZM0.0610352 6.08235C0.0610352 5.59561 0.455615 5.20103 0.942354 5.20103H15.0435C15.5302 5.20103 15.9248 5.59561 15.9248 6.08235V6.08235C15.9248 6.56909 15.5302 6.96367 15.0435 6.96367H0.942355C0.455616 6.96367 0.0610352 6.56909 0.0610352 6.08235V6.08235Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
